import {
  Dialog,
  Radio,
  DialogActions,
  Button,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { Team, TeamName } from '../types';

type AddPlayerDialogProps = {
  teams: Team[];
  onClose: () => void;
  onSubmit: (player: string, team: TeamName) => void;
};

export const AddPlayerDialog = ({
  teams,
  onClose,
  onSubmit,
}: AddPlayerDialogProps) => {
  const [player, setPlayer] = useState('');
  const [team, setTeam] = useState<TeamName | null>(null);

  return (
    <Dialog
      open
      onClose={onClose}
      PaperProps={{
        component: 'form',
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries((formData as any).entries());
          const { name, team } = formJson;
          onSubmit(name, team);
        },
      }}
    >
      <DialogTitle>Add player</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          required
          margin="dense"
          id="name"
          name="name"
          label="Player name"
          fullWidth
          variant="standard"
          onChange={(event) => setPlayer(event.target.value)}
        />
        <FormControl sx={{ mt: 2 }}>
          <FormLabel id="team">Team</FormLabel>
          <RadioGroup
            row
            name="team"
            onChange={(event) => setTeam(event.target.value as TeamName)}
          >
            {teams.map((team) => (
              <FormControlLabel
                key={team.name}
                value={team.name}
                control={<Radio />}
                label={team.name}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" disabled={!player || !team}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
